import { Form } from 'antd';

export function mapPropsToFields(props) {
  const { initialValue } = props;
  if (!initialValue) return;
  const keys = Object.keys(initialValue);
  return keys.reduce((ac, val) => {
    ac[val] = Form.createFormField({
      value: initialValue[val],
    });
    return ac;
  }, {});
}

export function getErrorMessages(err) {
  const errData = err?.response?.data;
  const errMessage = ['Error'];
  if (errData?.message) errMessage.push(errData.message);
  if (errData?.code === 'SCHEMA_VALIDATION_FAILED') {
    errData?.errors?.forEach((errObj) => {
      errMessage.push(`${errObj.path[0]} ${errObj.message}`);
    });
  }
  return errMessage;
}